import React, { useEffect, useState } from "react";
import styles from "./dashboard.module.scss";
import { connect } from "react-redux";
import {
  getPRMDashboardSummaryRequest,
  getPRMDashboardDetailRequest,
  clearPRMDashboardData,
} from "../../store/actions/general.actions";
import {
  prmDashboardSummary,
  prmDashboardDetail,
} from "../../store/selectors/general.selector";
import HealthTable from "./components/HealthTable";
import Timeline from "../timeline/timeline";
import { SharedTimelineContextProvider } from "../timeline/SharedTimelineContext";
import OverviewTable from "./OverviewTable";
import { useDispatch, useSelector } from "react-redux";
import SingleOverviewTable from "./SingleOverviewTable";
import { ArrowRight, Dot, Fullscreen, Minimize2 } from "lucide-react";
import { Button } from "@fluentui/react-components";
const ProgramManagerDashboard = (props) => {
  const {
    ProgramId,
    setProgramId,
    setProgramName,
    getPRMDashboardSummaryRequest,
    getPRMDashboardDetailRequest,
    clearPRMDashboardData,
    summary,
  } = props;

  const [projectHealth, setProjectHealth] = useState(null);
  const [overviewDetails, setOverviewDetails] = useState(null);
  const [isFullHeight, setIsFullHeight] = useState(false);
  const [loadingOverview, setLoadingOverview] = useState(true);
  const [isOverviewMounted, setIsOverviewMounted] = useState(false);
  const [loadingHealth, setLoadingHealth] = useState(true);
  const [isHealthMounted, setIsHealthMounted] = useState(false);
  const [isTimelineFullscreen, setIsTimelineFullscreen] = useState(false);
  
  const dispatch = useDispatch();

  const toggleTimelineFullScreen = () => {
    setIsTimelineFullscreen(!isTimelineFullscreen);
  }

  useEffect(() => {
    setOverviewDetails(null);
    setProjectHealth(null);
    setLoadingOverview(true);
    setLoadingHealth(true);

    dispatch(clearPRMDashboardData());
    if (ProgramId) {
      getPRMDashboardDetailRequest(ProgramId);
    } else {
      setIsTimelineFullscreen(false);
      getPRMDashboardSummaryRequest();
    }
  }, [ProgramId]);

  useEffect(() => {
    if (!summary) return;
    summary.hasOwnProperty("health") && setProjectHealth(summary.health);
    summary.hasOwnProperty("programs") && setOverviewDetails(summary.programs);
  }, [summary]);

  useEffect(() => {
    if (overviewDetails && isOverviewMounted) {
      setLoadingOverview(false);
    }
  }, [overviewDetails, isOverviewMounted]);

  useEffect(() => {
    if (projectHealth && isHealthMounted) {
      setLoadingHealth(false);
    }
  }, [projectHealth, isHealthMounted]);

  return (
    <>
      <div 
        className={`mt-4 ${styles.SummaryPanel}`}
        style={ isTimelineFullscreen ? {maxHeight: "calc(100vh - 190px)" , overflow: 'auto'} :{}}
      >
      {!isTimelineFullscreen ?
        (
          <>
                    <div className="row g-3 mb-3">
          <div className="col-12">
            {ProgramId ? (
              <SingleOverviewTable
                overviewDetails={overviewDetails}
                dashboardFilterSetId={setProgramId}
                dashboardFilterSetName={setProgramName}
                loading={loadingOverview}
                onComponentReady={() => setIsOverviewMounted(true)}
                entityType="Program"
              />
            ) : (
              <OverviewTable
                overviewDetails={overviewDetails}
                dashboardFilterSetId={setProgramId}
                dashboardFilterSetName={setProgramName}
                loading={loadingOverview}
                onComponentReady={() => setIsOverviewMounted(true)}
                entityType="Program"
              />
            )}
          </div>
        </div>
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="DashboardCard dbTableCard">
              <div className="d-flex align-items-center justify-content-between mb-6 DashboardCardHeader">
                <h5 className="font-weight-500">Health Status</h5>
                <div className="d-flex justify-content-center align-items-center gap-3">
                  <div className="d-flex justify-content-center align-items-center gap-3">
                    <div className="d-flex align-items-center justify-content-center gap-1 text-xsm-400">
                      <div className="current">
                        <Dot
                          size={20}
                          strokeWidth={8}
                          absoluteStrokeWidth
                          color="#AAAAAA"
                        />
                      </div>
                      Current
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1 text-xsm-400">
                      <div className="trending">
                        <ArrowRight
                          size={15}
                          strokeWidth={2}
                          absoluteStrokeWidth
                          color="#AAAAAA"
                        />
                      </div>
                      Trending
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1 text-xsm-400">
                      <div className="HealthBadge OnTrack"></div>
                      On Target
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1 text-xsm-400">
                      <div className="HealthBadge OffTrack"></div>
                      Monitoring
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1 text-xsm-400">
                      <div className="HealthBadge AtRisk"></div>
                      Slipping
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column">
                <HealthTable
                  projectHealth={projectHealth}
                  dashboardFilterSetId={setProgramId}
                  dashboardFilterSetName={setProgramName}
                  entityType="program"
                  loading={loadingHealth}
                  onComponentReady={() => setIsHealthMounted(true)}
                />
              </div>
            </div>
          </div>
        </div>
        {ProgramId && (
          <div className="row g-3">
            <div className="col-12">
              <div className="DashboardCard dbTableCard">
                <div className="d-flex align-items-center justify-content-between mb-6 DashboardCardHeader">
                  <h5 className="font-weight-500">Timeline</h5>
                  <Button
                      appearance="subtle"
                      size="small"
                      icon={<Fullscreen />}
                      onClick={toggleTimelineFullScreen}
                    />
                </div>
                <div className="d-flex flex-column h-100 align-items-center justify-content-center">
                  <SharedTimelineContextProvider>
                    <Timeline
                      entityID={ProgramId}
                      entityType="program"
                      isFullHeight={isFullHeight}
                      setFullHeight={setIsFullHeight}
                    />
                  </SharedTimelineContextProvider>
                </div>
              </div>
            </div>
          </div>
        )}
          </>
        )
      :
      <div className="row">
            <div className="col-12">
              <div className="DashboardCard dbTableCard">
                <div className="d-flex align-items-center justify-content-between mb-6 DashboardCardHeader">
                  <h5 className="font-weight-500">Timeline</h5>
                  <Button
                      appearance="subtle"
                      size="small"
                      icon={<Minimize2 />}
                      onClick={toggleTimelineFullScreen}
                    />
                </div>
                <div className="d-flex flex-column h-100 align-items-center justify-content-center">
                  <SharedTimelineContextProvider>
                    <Timeline
                      entityID={ProgramId}
                      entityType="program"
                      isFullHeight={true}
                      setFullHeight={setIsFullHeight}
                    />
                  </SharedTimelineContextProvider>
                </div>
              </div>
            </div>
          </div>
      }
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getPRMDashboardSummaryRequest,
  getPRMDashboardDetailRequest,
  clearPRMDashboardData,
};

const mapStateToProps = (state, ownProps) => {
  const summary = prmDashboardSummary(state);
  const detail = prmDashboardDetail(state);
  if (ownProps.ProgramId) {
    return {
      summary: detail && Object.keys(detail).length > 0 ? detail : summary,
    };
  } else {
    return { summary: summary };
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgramManagerDashboard);
